import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import IntroSection from "@/components/IntroSection";
import ProjectsSection from "@/components/ProjectsSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import StaffSection from "@/components/StaffSection";
import GallerySection from "@/components/GallerySection";
import ReviewsSection from "@/components/ReviewsSection";
import ZonesSection from "@/components/ZonesSection";
import CTASection from "@/components/CTASection";
import MapSection from "@/components/MapSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <IntroSection />
      <ProjectsSection />
      <AboutSection />
      <ServicesSection />
      <StaffSection />
      <GallerySection />
      <ReviewsSection />
      <ZonesSection />
      <CTASection />
      <MapSection />
      <Footer />
    </div>
  );
};

export default Index;